module.exports = __webpack_public_path__ + "static/media/app5.33a1db78.png";